import styled from 'styled-components';

import profileAvatarDefaultImage from '../../assets/images/profile-avatar-default.png';
import { resolveRenderableAvatarUrl } from '../model';

type UserAvatarProps = {
  avatarUrl?: string | null;
  className?: string;
  sizePx: number;
};

const AvatarImage = styled.img.attrs({
  alt: '',
  'aria-hidden': true,
})<{ $sizePx: number }>`
  width: ${({ $sizePx, theme }) => theme.scale.px($sizePx)};
  height: ${({ $sizePx, theme }) => theme.scale.px($sizePx)};
  border-radius: 50%;
  object-fit: cover;
  display: block;
`;

export function UserAvatar({
  avatarUrl = null,
  className,
  sizePx,
}: UserAvatarProps) {
  const avatarSource =
    resolveRenderableAvatarUrl(avatarUrl) ?? profileAvatarDefaultImage;

  return (
    <AvatarImage $sizePx={sizePx} className={className} src={avatarSource} />
  );
}
